import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useCart } from '@/contexts/CartContext';
import { MenuItem } from '@/types';

export const useCartSuggestions = (branchId: string) => {
  const { items } = useCart();
  
  const cartItemIds = items.map(item => item.menuItem.id);

  return useQuery({
    queryKey: ['cart-suggestions', branchId, cartItemIds],
    queryFn: async () => {
      if (!branchId || cartItemIds.length === 0) return [];

      const { data, error } = await supabase
        .rpc('get_cart_suggestions', {
          p_branch_id: branchId,
          p_cart_item_ids: cartItemIds,
          p_limit: 5
        });

      if (error) {
        console.error('Error fetching suggestions:', error);
        return [];
      }

      return data as MenuItem[];
    },
    enabled: !!branchId && cartItemIds.length > 0,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
